import * as React from "react";
import { forwardRef } from "react";
const SvgIndeterminate = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 2, viewBox: "0 0 8 2", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { width: 8, height: 2, rx: 1 }));
const ForwardRef = forwardRef(SvgIndeterminate);
export default ForwardRef;
